import { render, staticRenderFns } from "./DocumentUploaderInline.vue?vue&type=template&id=086a2d20&scoped=true"
import script from "./DocumentUploaderInline.vue?vue&type=script&lang=js"
export * from "./DocumentUploaderInline.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploaderInline.vue?vue&type=style&index=0&id=086a2d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a2d20",
  null
  
)

export default component.exports